import React from "react";
import styles from "./menuButton.module.less";
import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import {Link} from "react-router-dom";
import {useLocation} from "react-router";
import cn from "classnames";

interface Props extends React.PropsWithChildren {
    onClick?: (e: React.MouseEvent) => void
    disabled?: boolean
    icon?: React.ReactNode
    href?: string
    style?: React.CSSProperties
    active?: boolean
}


export const MenuLinkButton = ({href, icon, children, onClick, style, active}: Props) => {
    const location = useLocation()

    if (href) return (
        <Link to={href} className={cn(styles.clickableBoard, styles.linkWrapper, {[styles.active]: active})} state={{from: location}} style={style}>
            <Stack gap={8} alignItems={"center"} justifyContent={"flex-start"}>
                {icon && icon}
                {children}
            </Stack>
        </Link>
    )
    if (onClick) return (
        <Stack gap={8} alignItems={"center"} justifyContent={"flex-start"} onClick={onClick}
               className={cn(styles.clickableBoard, styles.linkWrapper, {[styles.active]: active})}
               style={style}>
            {icon && icon}
            {children}
        </Stack>
    )
}